module.exports = __webpack_public_path__ + "img/Eventos_darme_de_baja_rosa.0feda427.svg";